<template>
  <div class="loginWrap">
    <div class="login-content">
      <div class="login-img">
        <img class="login-imgs" src="../../public/static/images/login.png">
      </div>
      <div class="login-bg">
        <div class="login-bg-title">
          欢迎登录
        </div>
        <div class="login-input-call">
          <div class="login-input-item">
            <div class="login-input-label">
              <i class="icon etv etv-account"></i>
            </div>
            <nut-textinput :clearBtn="false" v-model="userName" placeholder="请输入账号"/>
          </div>
          <div class="login-input-item">
            <div class="login-input-label">
              <i class="etv icon etv-password"></i>
            </div>
            <nut-textinput v-model="userPwss" :clearBtn="false" placeholder="请输入密码" type="password"/>
          </div>
        </div>
      </div>
      <div class="login-btn">
        <nut-button block class="landing" @click="login">
          登录
        </nut-button>
      </div>
      <div class="login-btn" style="font-size: 12px;display: flex;justify-content: flex-end">
        <!--<span @click="goto">注册</span>-->
        <span>当前版本：4.1.5</span>
      </div>
      <a class="aq" href="https://beian.miit.gov.cn">
        粤ICP备18130949号-3
      </a>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import qs from 'qs'
import {Toast} from 'vant'

function decode(data) {
  try {
    var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
    key = CryptoJS.enc.Hex.parse(key)
    let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')

    var dec = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(data.data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })

    return JSON.parse(CryptoJS.enc.Utf8.stringify(dec))
  } catch (e) {
    console.warn(e)
  }
  return ''

}

export default {
  name: 'Login',
  data() {
    return {
      userName: '',
      userPwss: '',
      topTitle: '登入',
    }
  },
  mounted() {
    document.title = '亿晟信发小程序'
    window.onresize = () => {
      return (() => {
        this.handleLableWidth()
      })()
    }
    this.handleLableWidth()
  },
  methods: {
    getInifData() {
      this.$ajax.post("/etv/getUploadServer.json").then(res => {
        console.log(res.data.data);
        if (res.data.code === 0) {
           localStorage.setItem("upFileUrl", res.data.data)
          // localStorage.setItem("upFileUrl", "https://www.ysetv.cn/")
          this.$router.push('/terminal')
        }
      })
    },
    handleLableWidth() {
      if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
          window.setTimeout(function () {
          document.activeElement.scrollIntoViewIfNeeded()
        }, 0)
      }
    },
    login() {
      this.$ajax.post('/etv/login.htm', qs.stringify({
        'username': this.userName,
        'password': this.userPwss,
      })).then(res => {
        if (res.data.code === 0) {
          let data = decode(res.data)
          localStorage.setItem('token', data.token)
          localStorage.setItem('userId', data.id)
          localStorage.setItem('username', data.username)
          this.getInifData()

        } else {
          Toast(res.data.msg)
        }
      })
    },
    goto() {
      this.$router.push("/Register")
    }
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.loginWrap {
  height: 100%;
  overflow-y: auto;
}

.topTitle {
  height: 40px;
  background: #1B89FA;
  line-height: 40px;
  text-align: center;
  color: #fff;
}

.login-content {
  position: relative;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100%;
  padding-bottom: 35px;

  .login-img {
    margin-top: 30px;
    padding: 0 20px;
    margin-bottom: 20px;

    .login-imgs {
      width: 100%;

    }
  }

  .login-bg {
    padding: 8px 40px;
    box-sizing: border-box;

    .login-bg-title {
      font-size: 22px;
      font-weight: 700;
      color: $uni-text-color;
      margin-bottom: 25px;
    }

    .login-input-call {

      .login-input-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        border-bottom: 1px solid $uni-border-bottom-color;

        .login-input-label {
          color: $uni-border-bottom-color;
          margin-right: 10px;

          i {
            font-size: 24px;
          }
        }

        .nut-textinput {
          flex: 1;

          input {
            background: none;
          }
        }

        input {
          border-radius: 0;
          border: none;
        }

      }

      .login-input-item:nth-of-type(2) {
        margin-bottom: 10px;
      }

      .editServe {
        height: 20px;
        line-height: 20px;
        text-align: right;
        color: #999;
        font-size: 12px;
      }

    }
  }

  .login-btn {
    padding: 0 40px;
    margin-top: 15px;

    .landing {
      border-radius: 3px;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 3px;
      color: $uni-text-color-inverse;
      background: $uni-color-primary;
    }
  }

  .aq {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background: #2c3e50;
    color: white;
    font-size: 14px;
    display: inline-block;
    text-decoration: none;
  }

}
</style>
